import { Grid } from '@material-ui/core';
import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { AuthProviderWrapper } from 'src/auth/auth-context';
import { store } from 'src/common/redux/configure-store';
import Keyboard from 'src/keyboard/keyboard';
import CustomerDisplayProxy from '../customer-display/customer-display-proxy';
import { XLRStartupSequence } from './xlr-startup';

export const XLRPos: React.FC = () => {
  return (
    <ReduxProvider store={store}>
      <Grid container item justifyContent='center'>
        <Keyboard />
      </Grid>
      <AuthProviderWrapper>
        <XLRStartupSequence />
      </AuthProviderWrapper>

      <CustomerDisplayProxy />
    </ReduxProvider>
  );
};
